/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIPlaygroundModelComparisonResponse {
    getFixupPrototypeFunction() { return AIPlaygroundModelComparisonResponse.fixupPrototype; }

    static newInstance(model: Partial<AIPlaygroundModelComparisonResponse>): AIPlaygroundModelComparisonResponse {
        let obj = Object.assign(new AIPlaygroundModelComparisonResponse(), model);
        AIPlaygroundModelComparisonResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIPlaygroundModelComparisonResponse>): AIPlaygroundModelComparisonResponse {
        if (!model) return null;
        return AIPlaygroundModelComparisonResponse.newInstance(<AIPlaygroundModelComparisonResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIPlaygroundModelComparisonResponse) {
        if (!obj) return;

        models.AIPlaygroundModelComparisonResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIPlaygroundModelComparisonResponse): boolean {
        Object.setPrototypeOf(obj, AIPlaygroundModelComparisonResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let val of this.results) {
                models.AIPlaygroundInvokeResult.fixupPrototype(val);
            }
        }
    }

    /**
     * Comparison ID shared by all invocations
     */
    comparison_id: string;

    /**
     * Invocation results
     */
    results: Array<models.AIPlaygroundInvokeResult>;

}
